import { environment as base } from './environment.verv';

export const environment = {
  ...base,
  apiUrl: '#{apiUrl}#',
  production: true,
  bugsnagEnv: '#{bugsnagEnv}#',
  isOffline: '#{isOffline}#',
  offlineRegisterFormLink: '#{offlineRegisterFormLink}#'
};
